'use client';

import { WifiOff } from 'lucide-react';
import { useBrowserOnline } from '@workspace/ui/hooks/use-browser-online';

export function OfflineNotice() {
  const online = useBrowserOnline();

  if (online) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="pointer-events-none fixed inset-x-4 top-[calc(var(--header-height,64px)+0.75rem)] z-40 flex justify-center animate-fade-in print:hidden"
    >
      <div className="flex items-center gap-2 rounded-full border border-red-200 bg-white px-4 py-2 text-sm font-medium text-primary-darker animate-glow-breath-danger">
        <WifiOff className="size-4 shrink-0 text-red-500" aria-hidden="true" />
        <p>You're offline. Check your connection.</p>
      </div>
    </div>
  );
}
